import * as React from 'react'
import { FormHelperText } from '@mui/joy'
import useTranslation from '../../shared/TranslationProvider'

// CTS-9298 (YNS-012): FormHelperText associates error text with the field inside Joy FormControl.
const Errors = ({ errors, field }) => {
  const { t } = useTranslation()
  const translateField = (field) => {
    if (field === 'password_confirmation') return t('password')
    if (field === 'current_password') return t('password')
    return t(field)
  }

  if (field == 'password')
    return (
      errors &&
      errors.password && (
        <FormHelperText>
          <ul className="form-errors-list" role="list">
            <li className="form-error" key={`password-error-0`}>
              {t('ensure_password_guidelines')}
            </li>
          </ul>
        </FormHelperText>
      )
    )
  else
    return (
      errors &&
      errors[field] && (
        <FormHelperText>
          <ul className="form-errors-list" role="list">
            {errors[field].map((error, index) => (
              <li className="form-error" key={`${error}-${index}`}>
                {translateField(field)} {error}
              </li>
            ))}
          </ul>
        </FormHelperText>
      )
    )
}

export default Errors
